import script from "./HomePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomePage.vue?vue&type=script&setup=true&lang=ts"

import "./HomePage.vue?vue&type=style&index=0&id=5156bd9c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src057020910/src/SAAS-mobile-application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5156bd9c"]])

export default __exports__